function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M45.269,17.21c-0.038-0.029-0.083-0.038-0.123-0.061c0.058-0.542,0.09-1.092,0.09-1.649c0-8.547-6.954-15.5-15.502-15.5 H11.237c-0.498,0-0.921,0.367-0.99,0.86L3.781,46.865c-0.04,0.287,0.046,0.577,0.235,0.796c0.19,0.219,0.466,0.344,0.755,0.344 h10.326c-0.424,2.77-0.836,4.78-0.84,4.803c-0.061,0.294,0.015,0.601,0.204,0.833c0.19,0.233,0.475,0.368,0.775,0.368h10.32 c0.497,0,0.919-0.365,0.99-0.857l1.878-13.04h8.668c7.247,0,13.144-5.758,13.144-12.835C50.237,23.332,48.427,19.663,45.269,17.21z  M12.106,2h17.629c7.445,0,13.502,6.056,13.502,13.503C43.237,22.945,37.181,29,29.735,29H18.661c-0.498,0-0.921,0.367-0.99,0.861 l-2.269,16.144h-9.48L12.106,2z M37.094,38.111H27.56c-0.497,0-0.919,0.365-0.99,0.857l-1.878,13.04h-8.243 c0.199-1.067,0.496-2.76,0.779-4.721c0.002-0.012-0.003-0.023-0.002-0.035c0.01-0.037,0.031-0.07,0.036-0.109L19.53,31h10.205 c7.205,0,13.259-4.946,14.99-11.616c2.236,2.046,3.512,4.87,3.512,7.893C48.237,33.251,43.238,38.111,37.094,38.111z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

function SvgPaypal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54.009 54.009",
    style: {
      enableBackground: "new 0 0 54.009 54.009"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.8b9e36dc.svg";
export { ForwardRef as ReactComponent };